//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import $ from 'jquery';
//import intlTelInput from 'intl-tel-input';
//'$.fn.intlTelInput': 'intl-tel-input'
//import trackingCode from 'trackingCode';

export default {
    data: function data() {
        return {
            errorMessage: '',
            loading: false
        };
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        }
    },
    created: function created() {
        if (process.client && this.$auth.isAuthenticated()) {
            this.$router.push({ name: 'lang', params: { lang: this.lang } });
        }
    },
    mounted: function mounted() {
        if (process.client) {
            require('intl-tel-input');

            $("#phone_number").intlTelInput({
                initialCountry: 'auto',
                geoIpLookup: function geoIpLookup(callback) {

                    axios.get(global.getEndPoint() + 'api/common/geo-country').then(function (res) {
                        var countryCode = res.data.country;
                        callback(countryCode);
                    });

                    /*
                    $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
                        var countryCode = (resp && resp.country) ? resp.country : "";
                        callback(countryCode);
                    });
                    */
                }
                //, utilsScript: "/js/utils.js"
            });

            $('.flag-container').css('left', 0);
            $('.flag-container').css('right', 'auto');
            $('.selected-flag').css('padding', '0 0 0 8px');
            $('.iti-arrow').css('left', 'auto');
            $('.iti-arrow').css('right', '6px');
            $('.country-list').css('direction', 'ltr');
            $('.country-list').css('text-align', 'left');
            $('#phone_number').css('padding-left', '52px');
            $('#phone_number').css('padding-right', '6px');
            $('#phone_number').css('text-align', 'right');
            $('#phone_number').css('direction', 'ltr');
        }
    },

    methods: {
        login: function login() {
            var _this = this;

            if (this.validateLoginForm()) {
                this.loading = true;
                this.errorMessage = '';
                var phoneNumber = $("#phone_number").intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL);
                $("#phone_number").val(phoneNumber);
                axios.get(global.websiteSettings.extra_info.api_endpoint + 'api/tpay/login?phone_number=' + phoneNumber /*, {headers: {'X-Cookie': this.getAllCookies()}}*/).then(function (res) {
                    _this.loading = false;
                    if (res.data) {
                        if (res.data.success) {
                            //this.$auth.setToken(res.data.access_token, res.data.refresh_token, res.data.token_type, res.data.expires_in);
                            //this.$parent.$emit('login-logout-event');
                            _this.$router.push({ name: 'lang-pin-code' });
                        } else {
                            _this.errorMessage = _this.$root.trans('st_public.invalid_phone_number');
                        }
                    }
                });
            }
        },
        getAllCookies: function getAllCookies() {
            if (process.client) {
                return document.cookie;
            }
            return '';
        },
        validateLoginForm: function validateLoginForm() {
            var isValid = $("#phone_number").intlTelInput("isValidNumber");
            if (isValid) {
                return true;
            } else {
                this.errorMessage = this.$root.trans('st_public.invalid_phone_number');
            }
            return false;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/login-by-phone.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/login-by-phone.vue
// module chunks = 24